import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { isObject,isSet } from "../../../../../utils/commonUtils";
import FormInputs from "../../../../../components/UI/FormInputs";
// import { useLocation, useNavigate } from "react-router-dom";
// import LabService from "../../services/LabService";
// import { useToast } from '../../context/ToaxtContext';
// import LookupService from "../../../../services/LookupService";
// import ActivitiesService from "../../../../../services/ActivitiesService";
import WithRoutify from "../../../../../hoc/WithRoutify";
import VisitsService from "../../../../../services/VisitsService";
import WithRouter from "../../../../../hoc/WithRouter";
import { FieldValidationFocus } from "../../../../../utils/cssUtils";

const EZ_READER_ACTIVITY_TYPE = 'Drug Screen - EZ-Reader';

const getVisitActivities = (visitDetails) => {
  if (!visitDetails) {
    return [];
  }
  if (Array.isArray(visitDetails.mapping_activity)) {
    return visitDetails.mapping_activity;
  }
  return visitDetails?.mapping_activity?.data?.data || [];
};

const visitHasEzReaderActivity = (visitDetails) => {
  return getVisitActivities(visitDetails).some(
    (item) => item?.activity?.activity_type === EZ_READER_ACTIVITY_TYPE
  );
};

const AddActivities=(props)=>{
  const { isOpen,addToogleHandler, modelTitle,Toast,options,params,visitDetails} =props;
  const [validation,setValidation] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData,setFormData] = useState({
        visit_id: params.visitId,
        activity_id: '',
        cup_id: ''
      })

      const isEZReader = () => {
        const selected = options.find(opt => opt.value === formData.activity_id);
        return selected?.activity_type === EZ_READER_ACTIVITY_TYPE;
      };
      
        const inputFields = [
            
              {
                type: "SelectSearchList",
                label: "Activity",
                placeholder: "Activity Name",
                className: "form-control form-control-solid",
                name: "activity_id",
                options:options,
                value:formData.activity_id,
                required:true
              },
              {
                type: "",
                label: "Cup Id",
                placeholder: "Cup ID",
                className: "form-control form-control-solid",
                name: "cup_id",
                value: formData.cup_id,
                required: true,
                isShow: isEZReader(),
              },
        ];
        const changeHandler = (val, fieldName) => {
          let updatedFormData = {
            ...formData,
            [fieldName]: val
          };
          if (fieldName === "activity_id") {
            const selected = options.find(opt => opt.value === val);
            if (selected?.activity_type !== EZ_READER_ACTIVITY_TYPE) {
              updatedFormData.cup_id = '';
            }
          }
          setFormData(updatedFormData);
          setValidation({ ...validation, [fieldName]: '' });
        };
        
        
        const formSubmitHandler = async () => {
          if (isSubmitting) return;
          let updateValidation = { ...validation };
          let isValid = true;
          if (isEZReader() && visitHasEzReaderActivity(visitDetails)) {
            updateValidation.activity_id = "EZ Reader activity already exists for this visit.";
            isValid = false;
          }
          if (isEZReader() && !formData.cup_id) {
            updateValidation.cup_id = "CUP ID is required for EZ Reader";
            isValid = false;
          }
          if (!isValid) {
            setValidation(updateValidation);
            FieldValidationFocus(inputFields, updateValidation);
            return;
          }
          setIsSubmitting(true);
          try {
            const data = await VisitsService.saveActivityInChartVisits(
              isSet(formData.organization, null),
              formData
            );
            if (data.status === "ERROR") {
              if (isObject(data.data)) {
                for (let key in data.data) {
                  updateValidation[key] = data.data[key].join(",");
                }
              } else {
                Toast.error(data.data);
              }
              if (Object.keys(updateValidation).length > 0) {
                setValidation(updateValidation);
                FieldValidationFocus(inputFields, updateValidation);
              }
            } else {
              props.fetchVisitDetails();
              props.addToogleHandler();
              Toast.success("Activities Added Successfully");
            }
          } catch (err) {
            Toast.error("Error submitting activity");
          } finally {
            setIsSubmitting(false);
          }
        };
      return (
        <>
          <Modal show={isOpen} onHide={addToogleHandler} dialogClassName='' keyboard={false}
           contentClassName='h-100'
           backdrop="static" size="md">
           <div className="sh_modalBox1">
              <Modal.Header closeButton>
                <Modal.Title>
                  <h6 className="text-lg mb-0 font-weight-bold">
                    {modelTitle}
                  </h6>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                {inputFields
              .filter(field => field.isShow !== false) // ✅ Only render if not explicitly hidden
              .map((field, index) => (
                <div className="col-12" key={index}>
                  <div className="form-group">
                    <label className="mb-0 text-md opacity-75">{field.label}</label>
                    <FormInputs
                      {...field}
                      id={isSet(field.id, field.name)}
                      changeHandler={(value) => changeHandler(value, field.name)}
                    />
                    {isSet(validation[field.name], '') !== '' && (
                      <span className="text-danger m-1">{validation[field.name]}</span>
                    )}
                  </div>
                </div>
              ))}
                </div>
              </Modal.Body>
      
              <Modal.Footer className="d-flex justify-content-center">
                <Button variant="secondary" className="" onClick={addToogleHandler}>Cancel</Button>
                <Button variant="primary" className="" onClick={()=>formSubmitHandler()} disabled={isSubmitting}>
                  Submit
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        </>
      );
    };
export default WithRouter(WithRoutify(AddActivities));